module.exports = __webpack_public_path__ + "img/page404.f72472e7.png";